// extracted by mini-css-extract-plugin
export default {"landing-page-container":"landingPage_landing-page-container__hHzCl","landing-page-content":"landingPage_landing-page-content__F2oco"};